function _isFunction(x) {
  return Object.prototype.toString.call(x) === '[object Function]';
}
module.exports = _isFunction;


//////////////////
// WEBPACK FOOTER
// ../~/ramda/src/internal/_isFunction.js
// module id = 666
// module chunks = 0